// extracted by mini-css-extract-plugin
export var intro = "agenda-module--intro--14f2b";
export var wrapper = "agenda-module--wrapper--1da7f";